import React from 'react';
import { Typography } from 'antd';
import List from './List';

export default function Recipes(): React.ReactNode {
  return (
    <div>
      <Typography.Title level={4}>
        Рецепты
      </Typography.Title>
      <List />
    </div>
  );
}
